import * as React from "react";
import { useAppSelector, useAppDispatch } from "../app/hooks";

import {
  getListOfFarmersInfo,
  getListOfFieldBlocks,
  selectStatusListOfFarmes,
  selectStatusListOfFieldBlocks,
} from "../features/produtores/produtoresSlice";

//Components
import Appbar from "../features/Appbar/Appbar";
import ListaProdutores from "../features/produtores/ListaProdutores";
import Map from "../features/Mapa/Map";
import "mapbox-gl/dist/mapbox-gl.css";
import "../features/Mapa/map.css";
import CircularIndeterminate from "../features/LoadingInfo/CircularIndeterminate";
// import ScrollToTop from "../features/LoadingInfo/ScrollToTop";

//MaterialUI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

export default function Homepage() {
  const statusListOfFarmes = useAppSelector(selectStatusListOfFarmes);
  const statusListOfFieldBlocks = useAppSelector(selectStatusListOfFieldBlocks);

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (statusListOfFarmes === "start") {
      dispatch(getListOfFarmersInfo());
    }
    if (statusListOfFieldBlocks === "start") {
      dispatch(getListOfFieldBlocks());
    }
  });

  return (
    <React.Fragment>
      {statusListOfFarmes === "success" ? (
        <React.Fragment>
          {/* <ScrollToTop /> */}
          <Appbar />
          <Box
            sx={{
              flexGrow: 1,
              display: {
                xs: "block",
                sm: "block",
                md: "block",
                lg: "block",
                xl: "block",
              },
            }}
          >
            <Grid container>
              <Grid item xs={12}>
                <Map />
              </Grid>

              <Grid item xs={12}>
                <Box
                  // sx={{
                  //   height: "100vh",
                  //   overflow: "auto",
                  // }}
                  // paddingTop={0}
                  paddingBottom={3}
                >
                  <ListaProdutores />
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* <Box
            sx={{
              flexGrow: 1,
              display: {
                xs: "block",
                sm: "none",
                md: "none",
                lg: "none",
                xl: "none",
              },
            }}
          >
            <Grid container>
              <Grid item xs={12}>
                <Box
                  sx={{
                    height: "100vh",
                    overflow: "auto",
                  }}
                  paddingTop={6}
                  paddingBottom={3}
                >
                  <ListaProdutores />
                </Box>
              </Grid>
            </Grid>
          </Box> */}
        </React.Fragment>
      ) : (
        <CircularIndeterminate />
      )}
    </React.Fragment>
  );
}
